module.exports = __webpack_public_path__ + "img/Number=25.e1591fbd.png";